export type DocumentType = "contrat" | "piece-identite" | "recu" | "document-bien" | "facture" | "autre";

export interface DocumentItem {
  id: string;
  nom: string;
  type: DocumentType;
  date: string;
  immeubleId: string;
  bienId: string;
  contratId: string;
  locataireId: string;
  fichierUrl: string;
  fichierNom: string;
  fichierType: string;
  fichierTaille: number;
  createdAt: string;
}

export type DocumentInput = Omit<DocumentItem, "id" | "createdAt">;

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  contrat: "Contrat",
  "piece-identite": "Pièce d'identité",
  recu: "Reçu",
  "document-bien": "Document du bien",
  facture: "Facture",
  autre: "Autre",
};

export const DOCUMENT_TYPE_ICONS: Record<DocumentType, string> = {
  contrat: "ri-file-text-line",
  "piece-identite": "ri-id-card-line",
  recu: "ri-receipt-line",
  "document-bien": "ri-home-4-line",
  facture: "ri-file-list-3-line",
  autre: "ri-file-line",
};

export const DOCUMENT_TYPE_TONES: Record<DocumentType, "primary" | "accent" | "secondary" | "neutral"> = {
  contrat: "primary",
  "piece-identite": "secondary",
  recu: "secondary",
  "document-bien": "accent",
  facture: "accent",
  autre: "neutral",
};

export const DOCUMENT_TYPE_OPTIONS = (Object.keys(DOCUMENT_TYPE_LABELS) as DocumentType[]).map((value) => ({
  value,
  label: DOCUMENT_TYPE_LABELS[value],
}));

export function isImageDocument(doc: Pick<DocumentItem, "fichierType">): boolean {
  return doc.fichierType.startsWith("image/");
}

export function isPdfDocument(doc: Pick<DocumentItem, "fichierType">): boolean {
  return doc.fichierType === "application/pdf";
}

export function formatFileSize(bytes: number): string {
  if (!bytes || bytes <= 0) return "—";
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

/**
 * Modèle de données prévu pour Supabase.
 * Table cible : `documents`
 *   id uuid primary key default gen_random_uuid()
 *   owner_id uuid references auth.users(id)
 *   nom text not null, type text not null, date date not null
 *   immeuble_id uuid references immeubles(id) on delete set null
 *   bien_id uuid references biens(id) on delete set null
 *   fichier_url text, fichier_nom text, fichier_type text, fichier_taille bigint
 *   created_at timestamptz default now()
 * Le fichier sera stocké dans Supabase Storage ; seule l'URL publique sera conservée ici.
 */